// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes timer-pulse-076f0748{0%{box-shadow:0 0 0 0 rgba(122,204,51,.6)}70%{box-shadow:0 0 0 10px rgba(204,169,44,0)}to{box-shadow:0 0 0 0 rgba(204,169,44,0)}}.timer-dot-wrapper[data-v-076f0748]{align-items:center;display:flex}.bullet[data-v-076f0748]{border-radius:50%;height:10px;margin-right:4px;width:10px}.bullet.orange[data-v-076f0748]{background-color:#ffa64c}.bullet.green[data-v-076f0748]{background-color:#2aca22}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
